import Box from '@mui/material/Box';
import { nth } from 'lodash';
import { useCallback, useMemo } from 'react';
import useGetTokenFromLocalStorage from '@/hooks/use-get-token-from-local-storage';
import { composeMediaFmDownloadUrl } from '@/utils/compose';
import { resolveIcon } from '@/utils/icons';
import FormsResolver from '@/components/common/forms/forms-resolver';
import NoteTitle from '@/components/common/notes/note-title/note-title';

interface Props {
    fromExport?: boolean;
    note: {
        iconId?: string;
        name: string;
        createdAt: string;
        data: {
            auth: {
                firstName: string;
                lastName: string;
                username: string;
            };
            customFields: {
                coords: number[];
                forms: any;
                external_identification: any;
            };
            medias: {
                customFields: any;
                id: string;
            }[];
            signatures: any[];
        };
        customFields: any;
        forms: any;
        coords: any;
        configuration: {
            customFields: any;
            isForwarded: boolean;
            isForwarder: boolean;
        };
        typeNote: any;
    };
    avatarName: string;
    withTitle?: boolean;
}

const DisordersTreatmentNote = ({ note, avatarName, withTitle = true, fromExport = false }: Props) => {
    const getTokenFromLocalStorage: any = useGetTokenFromLocalStorage();
    const title = useMemo(() => note?.name, [note]);

    const time = useMemo(() => note?.createdAt, [note]);

    const coords: any = useMemo(() => {
        const tmp = note?.data?.customFields?.coords;

        if (!tmp) return undefined;

        return Array.isArray(tmp) && tmp.length > 0
            ? {
                  latitude: tmp[0],
                  longitude: tmp[1],
              }
            : tmp;
    }, [note]);

    const authInfo = useMemo(() => note?.data?.auth, [note]);

    const icon = useMemo(() => (note ? resolveIcon(note.iconId, 'LinearScale') : null), [note]);

    const formsData = useMemo(() => note?.data?.customFields?.forms, [note]);

    const defaultValues = useCallback(
        (formId: string) => {
            const data = note?.data;
            const formsValues = formsData[formId] ?? {};

            const media: any = nth(data?.medias, 0);

            return {
                ...formsValues,
                ...(media && {
                    media: {
                        src: composeMediaFmDownloadUrl(media.id, getTokenFromLocalStorage()),
                    },
                }),
            };
        },
        [formsData],
    );

    const isForwarder = useMemo(() => note?.configuration?.isForwarder, [note]);

    return (
        <Box
            sx={{
                display: 'grid',
                ...(!fromExport && {
                    gap: 1,
                    backgroundColor: 'white',
                    pt: 1,
                    borderRadius: 2,
                }),
            }}
        >
            {withTitle && <NoteTitle icon={icon} title={title} time={time} authInfo={authInfo} coords={coords} />}

            {!isForwarder && formsData && (
                <Box
                    sx={{
                        ...(!fromExport && {
                            p: 1,
                        }),
                    }}
                >
                    <FormsResolver name={avatarName} readOnly={true} defaultValues={defaultValues} />
                </Box>
            )}
        </Box>
    );
};

export default DisordersTreatmentNote;
